<div class="carousel">
  <div class="carousel-container">
    <ng-container
      *ngFor="let slide of slides; let i = index; trackBy: trackByFn"
    >
      <div
        *ngIf="i === activeIndex || i === prevIndex"
        class="slide"
        [class.z-10]="i === prevIndex"
        [class.z-20]="i === activeIndex"
      >
        <div class="slide-content">
          <div class="left-wrapper">
            <div class="heading-container">
              <h2 class="content-title">
                Built for
                <!-- <span
                  class="highlights"
                  [ngClass]="{
                    blue: slides[activeIndex].leftWrapper.shape === 'square',
                    green: slides[activeIndex].leftWrapper.shape === 'triangle',
                    yellow: slides[activeIndex].leftWrapper.shape === 'circle'
                  }"
                >
                  everyone</span
                > -->
                <om-gradient-text
                  [text]="'everyone'"
                  [gradientStart]="'rgba(0, 102, 253, 1)'"
                  [gradientEnd]="'rgba(239, 72, 253, 1)'"
                  styleClass="custom-gradient-text"
                ></om-gradient-text>
                in your ecosystem
                <span class="highlights">.</span>
                <!-- <om-gradient-text
                  [text]="'.'"
                  [gradientStart]="'rgba(0, 102, 253, 1)'"
                  [gradientEnd]="'rgba(239, 72, 253, 1)'"
                  styleClass="custom-gradient-text"
                ></om-gradient-text> -->
              </h2>
              <div class="navigation">
                <div class="dots">
                  <button
                    *ngFor="let slide of slides; let i = index"
                    class="dot"
                    [class.active]="i === activeIndex"
                    (click)="handleDotClick(i)"
                    [disabled]="isAnimating"
                  ></button>
                </div>
              </div>
            </div>
            <div
              class="left-text-wrap"
              [class]="getAnimationClasses(i, 'left')"
              [ngClass]="{
                newblueBg: slide.leftWrapper.shape === 'square',
                newgreenBg: slide.leftWrapper.shape === 'triangle',
                newyellowBg: slide.leftWrapper.shape === 'circle'
              }"
            >
              <!-- <img
                [src]="slide.leftWrapper.image"
                [alt]="slide.leftWrapper.title"
                class="profile-image"
              /> -->
              <div
                class="background-mini-image"
                [style.backgroundImage]="'url(' + slide.leftWrapper.image + ')'"
                alt="Left Image"
              ></div>
              <div
                class="left-down-wrapper"
                [ngClass]="{
                  blueBg: slide.leftWrapper.shape === 'square',
                  greenBg: slide.leftWrapper.shape === 'triangle',
                  yellowBg: slide.leftWrapper.shape === 'circle'
                }"
              >
                <div
                  class="shape-container"
                  [ngClass]="{
                    square: slide.leftWrapper.shape === 'square',
                    triangle: slide.leftWrapper.shape === 'triangle',
                    circle: slide.leftWrapper.shape === 'circle'
                  }"
                ></div>
                <h3 class="wrapper-title">
                  {{ slide.leftWrapper.title }}
                </h3>
                <p class="wrapper-description">
                  {{ slide.leftWrapper.description }}
                </p>
                <a
                  routerLink="/products/inforida-orbit"
                  [ngClass]="{
                    blue: slide.leftWrapper.shape === 'square',
                    green: slide.leftWrapper.shape === 'triangle',
                    yellow: slide.leftWrapper.shape === 'circle'
                  }"
                  >Learn More About Benifits →</a
                >
                <!-- <div class="new-navigation">
                  <div class="dots">
                    <button
                      *ngFor="let slide of slides; let i = index"
                      class="dot"
                      [class.active]="i === activeIndex"
                      (click)="handleDotClick(i)"
                      [disabled]="isAnimating"
                    ></button>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="new-navigation">
              <div class="dots">
                <button
                  *ngFor="let slide of slides; let i = index"
                  class="dot"
                  [class.active]="i === activeIndex"
                  (click)="handleDotClick(i)"
                  [disabled]="isAnimating"
                ></button>
              </div>
            </div>
          </div>

          <div
            class="right-content"
            [class]="getAnimationClasses(i, 'right')"
            [style.backgroundImage]="'url(' + slide.leftWrapper.image + ')'"
          >
            <!-- <img
              [src]="slide.leftWrapper.image"
              alt="Feature"
              class="feature-image"
            /> -->
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
